import { render, staticRenderFns } from "./ImportsProperties.vue?vue&type=template&id=b35d4cda"
import script from "./ImportsProperties.vue?vue&type=script&lang=js"
export * from "./ImportsProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports